/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OnboardingTermsRouteImport } from './routes/onboarding/terms'
import { Route as OnboardingStripeRouteImport } from './routes/onboarding/stripe'
import { Route as OnboardingMarketingRouteImport } from './routes/onboarding/marketing'
import { Route as OnboardingGpiRouteImport } from './routes/onboarding/gpi'
import { Route as HistoryTabRouteImport } from './routes/history/$tab'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingTermsRoute = OnboardingTermsRouteImport.update({
  id: '/onboarding/terms',
  path: '/onboarding/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingStripeRoute = OnboardingStripeRouteImport.update({
  id: '/onboarding/stripe',
  path: '/onboarding/stripe',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingMarketingRoute = OnboardingMarketingRouteImport.update({
  id: '/onboarding/marketing',
  path: '/onboarding/marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingGpiRoute = OnboardingGpiRouteImport.update({
  id: '/onboarding/gpi',
  path: '/onboarding/gpi',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryTabRoute = HistoryTabRouteImport.update({
  id: '/history/$tab',
  path: '/history/$tab',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/history/$tab': typeof HistoryTabRoute
  '/onboarding/gpi': typeof OnboardingGpiRoute
  '/onboarding/marketing': typeof OnboardingMarketingRoute
  '/onboarding/stripe': typeof OnboardingStripeRoute
  '/onboarding/terms': typeof OnboardingTermsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/history/$tab': typeof HistoryTabRoute
  '/onboarding/gpi': typeof OnboardingGpiRoute
  '/onboarding/marketing': typeof OnboardingMarketingRoute
  '/onboarding/stripe': typeof OnboardingStripeRoute
  '/onboarding/terms': typeof OnboardingTermsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/history/$tab': typeof HistoryTabRoute
  '/onboarding/gpi': typeof OnboardingGpiRoute
  '/onboarding/marketing': typeof OnboardingMarketingRoute
  '/onboarding/stripe': typeof OnboardingStripeRoute
  '/onboarding/terms': typeof OnboardingTermsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/history/$tab'
    | '/onboarding/gpi'
    | '/onboarding/marketing'
    | '/onboarding/stripe'
    | '/onboarding/terms'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/history/$tab'
    | '/onboarding/gpi'
    | '/onboarding/marketing'
    | '/onboarding/stripe'
    | '/onboarding/terms'
  id:
    | '__root__'
    | '/'
    | '/history/$tab'
    | '/onboarding/gpi'
    | '/onboarding/marketing'
    | '/onboarding/stripe'
    | '/onboarding/terms'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HistoryTabRoute: typeof HistoryTabRoute
  OnboardingGpiRoute: typeof OnboardingGpiRoute
  OnboardingMarketingRoute: typeof OnboardingMarketingRoute
  OnboardingStripeRoute: typeof OnboardingStripeRoute
  OnboardingTermsRoute: typeof OnboardingTermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/terms': {
      id: '/onboarding/terms'
      path: '/onboarding/terms'
      fullPath: '/onboarding/terms'
      preLoaderRoute: typeof OnboardingTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/stripe': {
      id: '/onboarding/stripe'
      path: '/onboarding/stripe'
      fullPath: '/onboarding/stripe'
      preLoaderRoute: typeof OnboardingStripeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/marketing': {
      id: '/onboarding/marketing'
      path: '/onboarding/marketing'
      fullPath: '/onboarding/marketing'
      preLoaderRoute: typeof OnboardingMarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/gpi': {
      id: '/onboarding/gpi'
      path: '/onboarding/gpi'
      fullPath: '/onboarding/gpi'
      preLoaderRoute: typeof OnboardingGpiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/$tab': {
      id: '/history/$tab'
      path: '/history/$tab'
      fullPath: '/history/$tab'
      preLoaderRoute: typeof HistoryTabRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HistoryTabRoute: HistoryTabRoute,
  OnboardingGpiRoute: OnboardingGpiRoute,
  OnboardingMarketingRoute: OnboardingMarketingRoute,
  OnboardingStripeRoute: OnboardingStripeRoute,
  OnboardingTermsRoute: OnboardingTermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
